// @ts-check
import React from 'react';

/** @typedef { "indigo" | "red" | "blue" | "green" | "orange" | "yellow" | "gray" } AppColor */

/** @type { Record<AppColor, string> } */
const colorClassNames = {
  indigo: 'bg-indigo-100 text-indigo-800',
  red: 'bg-red-100 text-red-800',
  blue: 'bg-blue-100 text-blue-800',
  green: 'bg-green-100 text-green-800',
  orange: 'bg-orange-100 text-orange-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  gray: 'bg-gray-100 text-gray-800',
};

/** @typedef {{
  color: AppColor;
  className?: string;
  children?: React.ReactNode;
}} BadgeProps */

/** @type { React.FC<BadgeProps> } */
export const Badge = (props) => {
  const { color, children, className = '' } = props;

  const cn = [
    'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
    colorClassNames[color],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={`_Badge ${cn}`}>{children}</span>;
};
